import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";

export class MenuNotification extends Phaser.GameObjects.Container {

    private readonly DEPTH: number = 1000;
    private shown!: boolean;

    constructor(scene: Scene, x: number, y: number) {
        super(scene);
        this.shown = false;

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.setDepth(this.DEPTH);
        this.setVisible(false);

        const icon = SpriteUtils.addImage(this.scene, 7, 7, Keys.ATLAS_UI_2, Keys.UI2_PLUS)
            .setOrigin(0, 0);

        this.add([icon]);
    }

    public show(delay: number) {

        if (!this.shown && this.scene) {
            this.scene.add.existing(this);
            let self = this;
            self.setAlpha(0);
            self.setVisible(true);

            this.scene!.tweens.chain({
                targets: self,
                tweens: [
                    {
                        alpha: 1,
                        delay: delay,
                        duration: 1000,
                    }
                ]
            });
            this.shown = true;
        }
    }

    public setShown(shown: boolean) {
        this.shown = shown;
    }
}
